import {
	ComHdmCommerceRestStoreHandlerHDMStoreHandlerSetDefaultRequest,
	ComHdmCommerceRestStoreHandlerHDMStoreHandlerSetDefaultResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class SetDefaultStore<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags Set Default Store
	 * @name SetDefault
	 * @summary Update physical store in the business context and get data related to the store.
	 * @request POST:/store/{storeId}/hdm/store/setDefault
	 * @response `200` `ComHdmCommerceRestStoreHandlerHDMStoreHandlerSetDefaultResponse` The requested completed successfully.
	 * @response `400` `void` Bad request. Some of the inputs provided to the request aren't valid.
	 * @response `401` `void` Not authenticated. The user session isn't valid.
	 * @response `403` `void` The user isn't authorized to perform the specified request.
	 * @response `404` `void` The specified resource couldn't be found.
	 * @response `500` `void` Internal server error. Additional details will be contained on the server logs.
	 */
	setDefault = (
		storeId: string,
		query?: {
			/** The response format. If the request has an input body, that body must also use the format specified in "responseFormat". Valid values include "json" and "xml" without the quotes. If the responseFormat isn't specified, the "accept" HTTP header shall be used to determine the format of the response. If the "accept" HTTP header isn't specified as well, the default response format shall be in json. */
			responseFormat?: 'xml' | 'json';
			/**
			 * Language identifier. If not specified, the "locale" parameter is used. If "locale" is not specified, then the store default language is used.
			 * @example "-1, -2, -3, -4, -5"
			 */
			langId?: string;
		},
		data?: ComHdmCommerceRestStoreHandlerHDMStoreHandlerSetDefaultRequest,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (loggerCan('trace') && (!this.http.traceDetails || this.http.traceDetails['setDefault'])) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/store/setDefault`,
				params: _params,
				query: query,
				body: data,
				methodName: 'setDefault',
			};
			logger.trace(traceData);
		}
		return this.http.request<ComHdmCommerceRestStoreHandlerHDMStoreHandlerSetDefaultResponse, void>(
			{
				path: `/store/${storeId}/hdm/store/setDefault`,
				method: 'POST',
				query: query,
				body: data,
				type: params.type ?? ContentType.Json,
				format: params.format ?? 'json',
				storeId,
				traceData,
				skipErrorLogging,
				..._params,
			}
		);
	};
}
